import script from "./summary.vue?vue&type=script&setup=true&lang=js"
export * from "./summary.vue?vue&type=script&setup=true&lang=js"

import "./summary.vue?vue&type=style&index=0&id=264fe69c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264fe69c"]])

export default __exports__